import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon/Icon';
import { Rotator } from '../Rotator/Rotator';
const CLOSE_ROTATION_DEG = 0;
const OPEN_ROTATION_DEG = 90;
export const ExpansionTableRowArrow = ({ open, }) => {
    const rotationInDeg = open ? OPEN_ROTATION_DEG : CLOSE_ROTATION_DEG;
    return (_jsx(Rotator, { rotationInDeg: rotationInDeg, children: _jsx(Icon, { name: 'ChevronRight', color: 'greyLight' }) }));
};
